import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

interface SalesTrendItem {
  day: string
  ventas: number
  utilidad: number
}

interface SalesTrendChartProps {
  data: SalesTrendItem[]
}

export function SalesTrendChart({
  data,
}: SalesTrendChartProps) {
  return (
    <div className="rounded-lg border border-border bg-card p-6">
      <h3 className="mb-4 font-semibold text-card-foreground">
        Tendencia de Ventas - Última Semana
      </h3>

      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="#e2e8f0"
          />

          <XAxis
            dataKey="day"
            stroke="currentColor"
          />

          <YAxis stroke="currentColor" />

          <Tooltip
            contentStyle={{
              backgroundColor: 'var(--card)',
              border: '1px solid var(--border)',
              borderRadius: '8px',
            }}
          />

          <Line
            type="monotone"
            dataKey="ventas"
            stroke="#3b82f6"
            strokeWidth={2}
            dot={{ r: 4 }}
            name="Ventas"
          />

          <Line
            type="monotone"
            dataKey="utilidad"
            stroke="#10b981"
            strokeWidth={2}
            dot={{ r: 4 }}
            name="Utilidad"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
